var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47803 10.368C3.47803 23.1733 13.8595 33.5548 26.6648 33.5548H30.1428C31.0653 33.5548 31.9499 33.1884 32.6022 32.5362C33.2544 31.8839 33.6209 30.9993 33.6209 30.0768V27.956C33.6209 27.1584 33.0783 26.4628 32.3039 26.2696L25.4668 24.5599C24.7867 24.3899 24.0725 24.6449 23.6536 25.2045L22.1542 27.2032C21.7183 27.7844 20.9655 28.041 20.2838 27.7906C17.7532 26.8602 15.455 25.3909 13.5485 23.4844C11.642 21.5779 10.1726 19.2797 9.24226 16.7491C8.99185 16.0674 9.24845 15.3146 9.82966 14.8787L11.8284 13.3792C12.3895 12.9603 12.643 12.2446 12.473 11.566L10.7633 4.72902C10.6692 4.35292 10.4522 4.01905 10.1466 3.78043C9.84108 3.54181 9.46455 3.41214 9.07687 3.41201H6.95605C6.03362 3.41201 5.14897 3.77844 4.49672 4.4307C3.84446 5.08295 3.47803 5.9676 3.47803 6.89003V10.368Z",
    stroke: "#959595",
    strokeWidth: 2.31868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact3);
export default __webpack_public_path__ + "static/media/contact3.d600cd8086ef16b5f91f34789e9acd4c.svg";
export { ForwardRef as ReactComponent };